import { t } from '@lingui/macro';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { onChangeParkingsAlertsTypeErrorFilter } from '../../../ac/onChangeMapFilters';
import { ParkingsAlertsPointsTypeErrorFilterValues } from '../../../constants/variables';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { StandardRadioGroup } from '../StandardRadioGroup';
import styles from '../FilterSidebar.module.css';

const ParkingsAlertsPointsTypeErrorFilterComponent = ({
    onChangeParkingsAlertsTypeErrorFilter,
    parkingsAlertsPointsTypeErrorStatuses,
}) => (
    <div style={{ width: '100%', maxWidth: '100%', overflow: 'hidden', boxSizing: 'border-box' }}>
        <div className={styles.legHead}>{t`Тип ошибки`}:</div>
        <StandardRadioGroup
            value={String(parkingsAlertsPointsTypeErrorStatuses)}
            onChange={onChangeParkingsAlertsTypeErrorFilter}
        >
            {
                ParkingsAlertsPointsTypeErrorFilterValues.map(({ label, value, color }) => (
                    <FormControlLabel
                        key={value}
                        className={styles.isochroneFilterLabel}
                        control={
                            <Radio
                                checked={parkingsAlertsPointsTypeErrorStatuses === value}
                                onChange={onChangeParkingsAlertsTypeErrorFilter}
                                value={value}
                                className={classnames(
                                    styles.isochroneFilterInput, {
                                        [styles.checkedIsochroneFilterInput]: parkingsAlertsPointsTypeErrorStatuses === value,
                                    }
                                )}
                                size='small'
                            />
                        }
                        label={
                            <span
                                title={label}
                                style={{
                                    fontSize: '12px',
                                    color,
                                    fontWeight: 'normal',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    minWidth: 0,
                                    display: 'block',
                                }}
                            >{t`${label}`}</span>
                        }
                        labelPlacement='end'
                    />
                ))
            }
        </StandardRadioGroup>
    </div>
);
const mapStateToProps = ({ mapFilters: { parkingsAlertsPointsTypeErrorStatuses } }) => ({ parkingsAlertsPointsTypeErrorStatuses });
const ConnectedComponent = connect(mapStateToProps, { onChangeParkingsAlertsTypeErrorFilter })(ParkingsAlertsPointsTypeErrorFilterComponent);

export const ParkingsAlertsPointsTypeErrorFilter = withDisplayedLayersCheck(ConnectedComponent, t`Алерты завершения парковки`);
